module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.38c81d5.otf";